import { Fragment } from 'react';
import cx from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import HeaderLogo from '../AppLogo';
import HeaderCompany from './Components/Company';
import UserInfo from './Components/UserInfo';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import useOutsideClick from '../../util/useOutsideClick';
import { setMenuMobileShow } from "../../reducers/models/menuData";

function Index() {

    const dispatch = useDispatch()
    const stateMenu = useSelector((state) => state.menuData);//Настройки приложения

    //Скроет меню
    const outsideClick = useOutsideClick(() => {
        dispatch(setMenuMobileShow({ data: false }));
    });

    return (
        <Fragment>
            <TransitionGroup>
                <CSSTransition
                    component="div"
                    classNames="app-header bg-strong-bliss header-text-light header-shadow appear-done enter-done"
                    appear={true}
                    timeout={1500}
                    enter={false}
                    exit={false}>
                    <div ref={outsideClick}>
                        <HeaderLogo />

                        <div className={cx(
                            "app-header__content",
                            { 'header-mobile-open': stateMenu.menuMobileShow },
                        )}>
                            <div className="app-header-left" >
                                <HeaderCompany />
                            </div>
                            <div className="app-header-right">
                                <UserInfo />
                            </div>
                        </div>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    );
}

export default Index;
